import React from 'react';
import cn from 'classnames';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './ImageText.module.scss';

const ImageText = ({ imgSrc, imgAlt, children, tag, variant }) => (
  <div
    data-bem="ImageText"
    data-tag={fromAnyToTrimmed(tag)}
    className={cn({
      [CN.component]: true,
      [CN[`${variant}Variant`]]: variant,
    })}
  >
    <div className={CN.column} data-bem="ImageText__text-column">
      <div className={CN.textContainer}> {children}</div>
    </div>
    <div className={CN.column} data-bem="ImageText__img-column">
      <div className={CN.imgContainer}>
        <img src={imgSrc} alt={imgAlt} className={CN.image} />
      </div>
    </div>
  </div>
);

export default ImageText;
